import { Tooltip } from "@mui/material";
import React, { useState } from "react";
import {
  AiFillCheckCircle,
  AiFillCheckSquare,
  AiFillStar,
  AiOutlinePlus,
} from "react-icons/ai";
import { IoMdRadioButtonOn } from "react-icons/io";
import { GrTextAlignLeft } from "react-icons/gr";
export default function SurveyAdd({ AddItemSurvey }) {
  const [visiblty, setvisiblty] = useState(false);

  function AddItem(type) {
    setvisiblty(false);
    AddItemSurvey(type);
    scrollBottom();
  }

  function scrollBottom() {
    setTimeout(function () {
      window.scrollTo({
        top: document.body.scrollHeight,
        left: 0,
        behavior: "smooth",
      });
    }, 100);
  }
  function AddNewQuestion() {
    setvisiblty(true);
    scrollBottom();
  }

  return (
    <>
      {!visiblty && (
        <Tooltip title="Yeni soru eklemenizi sağlar">
          <div className="divider">
            <AiOutlinePlus
              size={100}
              onClick={() => AddNewQuestion()}
              className=" text-gray-400 hover:text-gray-600 cursor-pointer"
            />
          </div>
        </Tooltip>
      )}

      {visiblty && (
        <div className=" m-10 flex md:flex-row flex-col ">
          <button className="btn mx-2 my-1" onClick={() => AddItem("multi")}>
            <AiFillCheckSquare size={28} />{" "}
            <div className="ml-2">Birden Çok Yanıt</div>
          </button>
          <button className="btn mx-2 my-1" onClick={() => AddItem("single")}>
            <IoMdRadioButtonOn color="white" size={28} />
            <div className="ml-2">Çoktan Seçmeli</div>
          </button>
          <button className="btn mx-2 my-1" onClick={() => AddItem("input")}>
            <GrTextAlignLeft size={28} />
            <div className="ml-2">Metinle Cevaplama</div>
          </button>
          <button className="btn mx-2 my-1" onClick={() => AddItem("score")}>
            <AiFillStar size={28} />
            <div className="ml-2">Seviyeli Cevaplama</div>
          </button>
          <button className="btn mx-2 my-1" onClick={() => AddItem("boolean")}>
            <AiFillCheckCircle  size={28} />
            <div className="ml-2">Evet/Hayır</div>
          </button>
        </div>
      )}
    </>
  );
}
